/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServiceProviderOutputDto { 
    id?: number;
    serviceProviderDbId?: number;
    name?: string | null;
    type?: string | null;
    description?: string | null;
    logoUrl?: string | null;
    visitUrl?: string | null;
    autoEnable?: number;
    subscribed?: boolean;
    status?: string | null;
    dbStatus?: string | null;
    username?: string | null;
    salesTeamEmail?: string | null;
    webhookEndpoint?: string | null;
}

